import { createClient } from '@sanity/client';

import {
  apiVersion,
  dataset,
  projectId,
  useCdn,
  isDevelopment,
  sanityDevToken,
} from '@dashboard/services/env';

export const sanityClient = createClient({
  apiVersion,
  dataset,
  projectId,
  useCdn,
});

export const previewsSanityDrafts = isDevelopment && Boolean(sanityDevToken);

export const sanityDraftsClient = previewsSanityDrafts
  ? createClient({
      apiVersion,
      dataset,
      projectId,
      useCdn: false,
      perspective: 'previewDrafts',
      token: sanityDevToken,
    })
  : sanityClient;

// The local drafts preview deliberately shows entries scheduled for the future.
export const changelogEntryFilter = previewsSanityDrafts
  ? '_type == "changelog-entry"'
  : '_type == "changelog-entry" && date <= now()';
